import navIconAccountsOld from 'assets/icons/nav-menu-old/account.inline.svg';
import navIconBizMilesOld from 'assets/icons/nav-menu-old/bizmiles.inline.svg';
import navIconDashboardSimplifiOld from 'assets/icons/nav-menu-old/dashboard.inline.svg';
import navIconInvestmentsSimplifiOld from 'assets/icons/nav-menu-old/investments.inline.svg';
import navIconReportsOld from 'assets/icons/nav-menu-old/reports.inline.svg';
import navIconGoalsOld from 'assets/icons/nav-menu-old/savingsGoals.inline.svg';
import navIconSettingsSimplifiOld from 'assets/icons/nav-menu-old/settings.inline.svg';
import navIconFtsOld from 'assets/icons/nav-menu-old/spendingPlan.inline.svg';
import navIconTransactionsSimplifiOld from 'assets/icons/nav-menu-old/transactions.inline.svg';
import navIconUpcomingOld from 'assets/icons/nav-menu-old/upcoming.inline.svg';
import navIconWatchlistOld from 'assets/icons/nav-menu-old/watchlist.inline.svg';

import navIconBillsAndPayments from 'assets/icons/nav-icons/billsAndPayments.inline.svg';
import navIconClients from 'assets/icons/nav-icons/clients.inline.svg';
import navIconDashboard from 'assets/icons/nav-icons/dashboard.inline.svg';
import navIconHelp from 'assets/icons/nav-icons/help.inline.svg';
import navIconInvestments from 'assets/icons/nav-icons/investments.inline.svg';
import navIconInvoice from 'assets/icons/nav-icons/invoice.inline.svg';
import navIconMileageIcon from 'assets/icons/nav-icons/mileage.inline.svg';
import navIconNotifications from 'assets/icons/nav-icons/notifications.inline.svg';
import navIconPlanningTools from 'assets/icons/nav-icons/planningTools.inline.svg';
import navIconProfile from 'assets/icons/nav-icons/profile.inline.svg';
import navIconRefresh from 'assets/icons/nav-icons/refresh.inline.svg';
import navIconReports from 'assets/icons/nav-icons/reports.inline.svg';
import navIconSavingsGoals from 'assets/icons/nav-icons/savingsGoals.inline.svg';
import navIconSettings from 'assets/icons/nav-icons/settings.inline.svg';
import navIconSpendingPlan from 'assets/icons/nav-icons/spendingPlan.inline.svg';
import taxPlanner from 'assets/icons/nav-icons/taxPlanner.inline.svg';
import navIconTransactions from 'assets/icons/nav-icons/transactions.inline.svg';
import navIconWatchlist from 'assets/icons/nav-icons/watchlist.inline.svg';

import navIconCategories from 'assets/icons/settings-menu/categories.tags.settings.simplifi.inline.svg';
import navIconRecurring from 'assets/icons/settings-menu/recurring.settings.simplifi.inline.svg';
import navIconTags from 'assets/icons/tags.svg';

export {
  navIconDashboardSimplifiOld,
  navIconTransactionsSimplifiOld,
  navIconInvestmentsSimplifiOld,
  navIconSettingsSimplifiOld,
  navIconFtsOld,
  navIconRecurring,
  navIconAccountsOld,
  navIconCategories,
  navIconTags,
  navIconGoalsOld,
  navIconUpcomingOld,
  navIconReportsOld,
  navIconWatchlistOld,
  navIconBizMilesOld,
  navIconBillsAndPayments,
  navIconClients,
  navIconDashboard,
  navIconHelp,
  navIconInvestments,
  navIconInvoice,
  navIconNotifications,
  navIconPlanningTools,
  navIconProfile,
  navIconRefresh,
  navIconReports,
  navIconSavingsGoals,
  navIconSettings,
  navIconSpendingPlan,
  navIconTransactions,
  navIconWatchlist,
  taxPlanner,
  navIconMileageIcon,
};
